import React from "react";
import "./Sidebar.css";
import { NavLink, useNavigate } from "react-router-dom";
import { IoHomeSharp, IoCalendar, IoFlask, IoReceipt, IoStatsChart, IoSettingsSharp, IoLogOutOutline, IoDocumentText, IoList, IoCube } from "react-icons/io5";
import Logo from "../../assets/Logo.png";
import { useAuth } from "../../AuthProvider";

const NAV = [
  { to: "/", label: "Home", Icon: IoHomeSharp, end: true },
  { to: "/appointments", label: "Bookings", Icon: IoCalendar },
  { to: "/results", label: "Results", Icon: IoDocumentText },
  { to: "/tests", label: "Definitions", Icon: IoList },
  { to: "/catalogue", label: "Catalogue", Icon: IoFlask },
  { to: "/packages", label: "Packages", Icon: IoCube },
  { to: "/billing", label: "Billing", Icon: IoReceipt },
  { to: "/analytic", label: "Analytics", Icon: IoStatsChart },
];

const Item = ({ to, label, Icon, end }) => (
  <NavLink to={to} end={end} className={({ isActive }) => (isActive ? "activelink" : "link")}>
    {({ isActive }) => (
      <>
        <Icon size={28} color={isActive ? "#ffb703" : "#ffffff"} />
        <div className="title">{label}</div>
      </>
    )}
  </NavLink>
);

const Sidebar = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="side_bar-container">
      <div className="side_bar-top">
        <div className="linkImg">
          <img className="imageLogo" src={Logo} alt="" />
        </div>
        <div className="side_items">
          {NAV.map((n) => <Item key={n.to} {...n} />)}
        </div>
      </div>

      <div className="side_bar-bottom">
        <Item to="/setting" label="Settings" Icon={IoSettingsSharp} />
        <div className="link" onClick={onLogout} role="button" style={{ cursor: "pointer" }}>
          <IoLogOutOutline size={28} color="#ffffff" />
          <div className="title">Logout</div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
